/**
 * VaultGraphPane — embedded graph view inside the three-pane window.
 *
 * C.5 used a hand-rolled SVG layout. C.7 replaces with the shared
 * VaultGraphCanvas backed by XYFlow + ELK. Controls are hidden in the
 * embedded variant; the popout window keeps them.
 */

import { VaultGraphCanvas, type VaultGraphCanvasProps } from './VaultGraphCanvas';

export type VaultGraphPaneProps = Omit<
  VaultGraphCanvasProps,
  'showControls' | 'initialMode'
>;

export function VaultGraphPane(props: VaultGraphPaneProps) {
  return (
    <VaultGraphCanvas
      {...props}
      initialMode="force"
      showControls={false}
    />
  );
}
